module.exports = __webpack_public_path__ + "img/dogImg.963a5f2f.png";